import { Injectable, NgZone, inject } from '@angular/core';
import { SeuUiState } from '@seu-types';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  private readonly zone = inject(NgZone);

  private readonly uiState$$ = new BehaviorSubject<SeuUiState>({
    navigationTopVariant: 'offers',
    isNavigationSideVisible: false,
  });

  public readonly navigationSideDetailScrollTop$ = new Subject<void>();

  public readonly uiState$ = this.uiState$$.asObservable();

  public setUiState(delta: Partial<SeuUiState>): void {
    this._setState(delta, this.uiState$$);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _setState(delta: Partial<any>, source: BehaviorSubject<any>): void {
    this.zone.run(() => {
      const state = source.getValue();
      const newState = { ...state, ...delta };
      source.next(newState);
    });
  }
}
